<template>
  <section class="form-list">
    <el-form
        ref="form"
        class="form form-extra-large"
        label-position="left"
        label-width="160px"
    >
      <el-form-item label="ID">{{ id }}</el-form-item>
      <el-form-item label="添加时间">{{ postData.add_time | timeToYmdHis }}</el-form-item>
      <el-form-item label="错误内容">{{ postData.content }}</el-form-item>

      <el-form-item>
        <el-button @click="RouteConfig.errorLogList.back">返回</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show } from '@/api/error-log';

export default {
  name: RouteConfig.errorLogDetail.name,
  data: () => ({
    RouteConfig,
    postData: {},
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    async show() {
      const { isError, data } = await show(this.id);
      if (isError || !data) return;
      this.postData = data;
    },
  },
};
</script>
